<template>
  <div v-if="session.application === Consts.APPLICATION.BEESECURE">
    <v-subheader>
      Comment
    </v-subheader>
    <div
      layout="row"
      class="font-weight-light subheading"
    >
      {{ session.comments }}
    </div>
  </div>
</template>
<script>
import Consts from "@/consts";
export default {
	props: {
		session: {
			type: Object,
			required: true,
			default: () => {}
		}
	},
  data() {
		return {
      Consts
    }
  }
}
</script>
<style scoped>
	.v-subheader {
		padding: 0 10px;
	}
</style>